import { useTranslation } from 'react-i18next';

import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Answer } from '@/components/question/forms/shared/Answer';
import { QuizAnswerCreateDTO } from '@/models/Answer';

type QuizAnswerTextProps = {
  answer: QuizAnswerCreateDTO;
  isEditing: boolean;
  onStartEdit: () => void;
  onFinishEdit: () => void;
  onUpdateText: (text: string) => void;
  onSwitchToMedia: () => void;
  onToggleCorrect: () => void;
  onDelete: () => void;
};

export default function QuizAnswerText({
  answer,
  isEditing,
  onStartEdit,
  onFinishEdit,
  onUpdateText,
  onSwitchToMedia,
  onToggleCorrect,
  onDelete,
}: QuizAnswerTextProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.questionsTab.createQuestionModal.quizForm',
  });

  return (
    <Answer isCorrect={answer.isCorrect} isEditing={isEditing}>
      <ConditionalRenderer
        condition={isEditing}
        fallback={<Answer.TextPreview text={answer.text} />}
      >
        <Answer.TextInput
          initialValue={answer.text ?? ''}
          placeholder={t('optionPlaceholder')}
          onConfirm={text => {
            onUpdateText(text);
            onFinishEdit();
          }}
          onCancel={onFinishEdit}
        />
      </ConditionalRenderer>
      <Answer.MoreOptions>
        <Answer.MoreOptions.EditText onClick={onStartEdit} />
        <Answer.MoreOptions.EditMedia onClick={onSwitchToMedia} />
        <Answer.MoreOptions.ToggleCorrect
          isCorrect={answer.isCorrect}
          onClick={onToggleCorrect}
        />
        <Answer.MoreOptions.Delete onClick={onDelete} />
      </Answer.MoreOptions>
    </Answer>
  );
}
